import { IRetencaoFonte } from "../interfaces/IRetencaoFonte";
import api from "./Api";
import Swal from 'sweetalert2';

class RetencaoFonteService {
  
  async obterTodos(funcaoSucesso?: (data: IRetencaoFonte[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IRetencaoFonte[]>('RetencaoFonte');

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }
  
  async obterPorId(id: number, funcaoSucesso?: (data: IRetencaoFonte) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.get<IRetencaoFonte>(`RetencaoFonte/${id}`);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async criar(parametro: IRetencaoFonte, funcaoSucesso?: (data: IRetencaoFonte) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.post('RetencaoFonte', parametro);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async atualizar(parametro: IRetencaoFonte, funcaoSucesso?: (data: IRetencaoFonte) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result } = await api.put(`RetencaoFonte/${parametro.id}`, parametro);

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async excluir(id: number, funcaoSucesso?: () => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      await api.delete(`RetencaoFonte/${id}`);

      funcaoSucesso && funcaoSucesso();

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }

  async obterTodosTipos(funcaoSucesso?: (data: IRetencaoFonte[]) => void, textoPopupSucesso?: string): Promise<boolean> {
    try {
      const { data: result} = await api.get('TipoRetencaoFonte');

      funcaoSucesso && funcaoSucesso(result);

      textoPopupSucesso && Swal.fire({
        text: textoPopupSucesso,
        timer: 3000,
        icon: 'success',
        showConfirmButton: false
      });

      return true;
    } catch (error: any) {
      Swal.fire({
        text: error.message,
        timer: 4000,
        icon: 'error',
        showConfirmButton: false
      });

      return false;
    }
  }
}


export default new RetencaoFonteService();